// extracted by mini-css-extract-plugin
export default {"swiper-slide-active":"SCarDetaiTermsAndConditionsSection_swiper-slide-active__hkSSI","wrapper":"SCarDetaiTermsAndConditionsSection_wrapper__Pcznl"};